/**
 * useOptionalAuth — safe auth access outside AuthProvider.
 * Returns null when called outside AuthProvider (e.g. unprotected routes).
 * Kept in a non-component .ts file so react-refresh/only-export-components
 * does not count it against AuthContext.tsx.
 */
import { useAuth } from '@/contexts/AuthContext';
import type { AuthContextType } from '@/contexts/AuthContext';

export const useOptionalAuth = (): AuthContextType | null => {
  try {
    return useAuth();
  } catch {
    return null;
  }
};

export const useOptionalUser = () => useOptionalAuth()?.user ?? null;
